import { PROJECT_TYPE } from '../console.types';

export const isMarketplaceProject = (projectType: PROJECT_TYPE) =>
  [PROJECT_TYPE.MARKETPLACE_AWS, PROJECT_TYPE.MARKETPLACE_AZURE, PROJECT_TYPE.N4GCP, PROJECT_TYPE.GCP_ISAAS].includes(
    projectType,
  );
